import { create } from "zustand";

type State = {
  organisersList: any;
  eventsList: any;
  exhibitorsList: any;
};

type Action = {
  setOrganisersList: (payload: any) => void;
  setEventsList: (payload: any) => void;
  setExhibitorsList: (payload: any) => void;
};

const useEnquiryStore = create<State & Action>((set) => ({

  organisersList: [],
  setOrganisersList: (payload: any) => set({ organisersList: payload }),

  eventsList: [],
  setEventsList: (payload: any) => set({ eventsList: payload }),

  exhibitorsList: [],
  setExhibitorsList: (payload: any) => set({ exhibitorsList: payload }),

}));

export default useEnquiryStore;
